import React, { useEffect } from 'react';
import { getEnv } from '@config';
import { usePromotions, useScript } from '@hooks';
import { AppLoader } from '@components/AppLoader';

export const FalabellaSellerCA = () => {
  const { sellerCheckingCreditWithAccountUrl } = getEnv();
  useScript(sellerCheckingCreditWithAccountUrl, 'module');

  const {
    tokenForCreditWithAccountWidget,
    getTokenForCreditWithAccountWidget,
    isCreditWithAccountTokenLoading,
    setTokenForCreditWithAccountLoading,
  } = usePromotions();

  useEffect(() => {
    getTokenForCreditWithAccountWidget();
    return () => {
      setTokenForCreditWithAccountLoading();
    };
  }, [getTokenForCreditWithAccountWidget, setTokenForCreditWithAccountLoading]);

  return (
    <>
      {isCreditWithAccountTokenLoading ? (
        <AppLoader />
      ) : (
        <falabella-seller-credits
          token={tokenForCreditWithAccountWidget}
          data-testId="finance-datamart-widget"
        />
      )}
    </>
  );
};

export default FalabellaSellerCA;
